import { type ReactNode } from 'react';
import { useEscapeKey } from '../../../../hooks/useEscapeKey';

interface ConfirmModalShellProps {
    widthClassName: string;
    dismissible: boolean;
    onDismiss: () => void;
    children: ReactNode;
}

export function ConfirmModalShell({
    widthClassName,
    dismissible,
    onDismiss,
    children
}: ConfirmModalShellProps) {
    useEscapeKey(onDismiss, dismissible);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-35 z-50 flex items-center justify-center">
            <div
                role="dialog"
                aria-modal="true"
                className={`bg-white rounded-xl shadow-xl overflow-hidden flex flex-col max-h-[calc(100vh-48px)] ${widthClassName}`}
            >
                {children}
            </div>
        </div>
    );
}
